import axios from 'axios'
import { getAuth } from 'firebase/auth'
import { API_URL } from './constants/constants'
import { onErrorResponse } from 'lib/api/errorMiddleware'

export { parseErrorMessage } from 'lib/api/errorMiddleware'

const api = axios.create({
  baseURL: API_URL,
})

export const apiWithFetchAdapter = axios.create({
  baseURL: API_URL,
  adapter: 'fetch',
})

export default api

// this method ensures that the auth token is always up-to-date
export async function getAuthToken(
  forceRefresh = false
): Promise<string | null> {
  return new Promise((resolve) => {
    const unsubscribe = getAuth().onIdTokenChanged(async (user) => {
      if (user) {
        const token = await user.getIdToken(forceRefresh)
        resolve(token)
      } else {
        resolve(null)
      }
      unsubscribe()
    })
  })
}

const setAuthToken = async (config) => {
  const idToken = await getAuthToken()
  if (idToken) {
    config.headers.Authorization = `Bearer ${idToken}`
  }

  return config
}

api.interceptors.request.use(setAuthToken)
apiWithFetchAdapter.interceptors.request.use(setAuthToken)

api.defaults.headers.common['Content-Type'] = 'application/json'
api.defaults.headers.common['Accept'] = 'application/json'
api.defaults.headers.common['App-Source'] = 'adminui'

apiWithFetchAdapter.defaults.headers.common['Content-Type'] = 'application/json'
apiWithFetchAdapter.defaults.headers.common['Accept'] = 'application/json'
apiWithFetchAdapter.defaults.headers.common['App-Source'] = 'adminui'

api.interceptors.response.use((response) => response, onErrorResponse)
